export default "__VITE_ASSET__CLLoLqsA__"